export const BORDER_RADIUS = "4px";

//font sizes
export const FONT_SIZE_SUBTITLE = "12px";
export const FONT_SIZE_BODY = "16px";
